import React from 'react';
import { Progress, Tooltip } from 'antd';
import { getAlertColorCode } from '../../../../util/miscellaneousUtils';
import AlertLevels from '../../../common/components/AlertLevels';
import {
  convertISOToDateFormat,
  convertISOToDateTimeFormat
} from '../../../../util/timezone';

import style from './index.scss';

import { capitalize, orderBy } from '../../../../util/lodashlike';
const getColumnRender = (
  column,
  record,
  alertIdClickHandler,
  getLevelLabel,
  getLevelColor
) => {
  switch (column.itemName) {
    case 'hitsSummary':
      return <AlertLevels data={record.hitsSummary} />;
    case 'alertLevel':
      return (
        <p>{record.alertLevelLabel || capitalize(record[column.itemName])}</p>
      );
    case 'alertScore':
      return (
        <div className={style.flex} key={record.alertId}>
          <Tooltip title={record[column.itemName]}>
            <p className={style.alertScore}>
              {record[column.itemName]?.toFixed(2)?.toString()}
            </p>
          </Tooltip>
          <Progress
            percent={record.alertScore}
            strokeColor={record.alertLevelColor}
            showInfo={false}
          />
        </div>
      );
    case 'alertId':
      return (
        <p
          className={style.tableLink}
          onClick={() => alertIdClickHandler(record[column.itemName])}>
          {record[column.itemName]}
        </p>
      );
    case 'alertDate':
      return <p>{convertISOToDateFormat(record[column.itemName])}</p>;
    case 'txnDateTime':
      return <p>{convertISOToDateTimeFormat(record[column.itemName])}</p>;
    case 'reviewStatus':
      return (
        <div
          className={style.reviewStatus}
          style={{
            color: record.reviewStatus === 'Completed' ? '#71C969' : '#748aa1'
          }}>
          {record[column.itemName] ? record[column.itemName] : '--'}
        </div>
      );
    case 'reviewFeedback':
      if (record[column.itemName])
        return (
          <div
            className={style.reviewFeedbackBadge}
            style={{ background: getLevelColor(record.reviewFeedback) }}>
            {getLevelLabel(record[column.itemName]) || record[column.itemName]}
          </div>
        );
      else return <div>--</div>;
    case 'primaryPartyName':
      return (
        <p>
          {record[column.itemName]}
          {record.isWhitelisted && (
            <Tooltip
              placement="right"
              overlayClassName={style.whiteList_tooltip}
              title={'Whitelisted'}>
              <i
                className="fa fa-flag-o"
                aria-hidden="true"
                style={{ fontSize: '12px', padding: '4px' }}></i>
            </Tooltip>
          )}
        </p>
      );
  }
  return null;
};

const widthConfig = {
  hitsSummary: '200px',
  alertLevel: '130px',
  origTxnAmount: '115px'
};

export const parseColumnsForRunInstanceResultListing = (
  settings,
  alertIdClickHandler,
  getLevelLabel,
  getLevelColor
) => {
  let columns = null;
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']).filter(
      (column) => column.columnVisibility
    );
    columns = sortedSettings.map((setting) => {
      return {
        title: (
          <div className={style.tableHeader}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => (
                <p key={idx} className={style.strong}>
                  {column.itemLabel}
                </p>
              ))}
          </div>
        ),
        width:
          orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
            .filter((column) => column.visibility)
            .map((column) => widthConfig[column.itemName])
            .find(Boolean) || null,

        render: (text, record) => (
          <div className={style.tableContent}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (
                  getColumnRender(
                    column,
                    record,
                    alertIdClickHandler,
                    getLevelLabel,
                    getLevelColor
                  ) !== null
                )
                  return getColumnRender(
                    column,
                    record,
                    alertIdClickHandler,
                    getLevelLabel,
                    getLevelColor
                  );
                else if (setting.columnDetail.length >= 2)
                  return (
                    <p key={record.alertId + idx} className={style.mutliRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
                else
                  return (
                    <p
                      key={record.alertId + idx}
                      className={style.singleRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
              })}
          </div>
        )
      };
    });
  }
  return columns;
};
